import {
  Component, TemplateRef, ViewChild, Input, Output, OnDestroy, EventEmitter, OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { tap, map, switchMap } from 'rxjs/operators';
import {
  ModalService, UIKitIconRegistry, downloadIcon, ModalOptions, closeIcon, RestApiService, SecureFilePipe,
} from '@ui-kit';
import { P } from '@ui-kit/ui-kit';

import { UserService } from '../../service/user.service';
import { ukPhoneRegex } from '../../shared.helpers';
import { environment } from '../../../../environments/environment';
import { WorkingService } from '../../service/working.service';
import { asapScheduler } from 'rxjs';

const MODAL_ID = 'mip-modal';

@Component({
  selector: 'app-mip-modal',
  templateUrl: './mip-modal.component.html',
  styleUrls: ['./mip-modal.component.scss'],
})
export class MipModalComponent implements OnInit, OnDestroy {

  @ViewChild('modalTmpl', { static: true }) modalTmpl: TemplateRef<HTMLDivElement>;

  @Output() onClose = new EventEmitter();

  @Output() onSuccess = new EventEmitter();

  @Input()
  set open(open: boolean) {
    if (!!open) {

      this.toggle.signedIn = this.user.signedIn;

      this.form
        .patchValue({
          agree_tanc: false,
          clean_credit: false, // this.user.current.application.has_clean_credit_record || false,
          phone: this.user.current.phone || ''
        })

      this.modal
        .open(this.modalTmpl, this.modalOptions);

    } else if (this.modal.isOpen(MODAL_ID)) {

      this.form.enable();

      this.onClose.emit();

      this.modal.closeAll();
    }
  }

  form: FormGroup = this.formBuilder.group({
    agree_tanc: [
      { value: false, disabled: false },
      Validators.compose([Validators.requiredTrue]),
    ],
    clean_credit: [
      { value: '', disabled: false },
      Validators.compose([Validators.requiredTrue]),
    ],
    phone: [
      { value: this.user.current?.phone || '', disabled: false },
      Validators.compose([Validators.pattern(ukPhoneRegex), Validators.required]),
    ],
  });

  modalOptions: Partial<ModalOptions> = {
    id: MODAL_ID,
    nav: false,
    maxWidth: 'm',
    disableClickOut: true,
    disableEsc: true
  };

  toggle: Dictionary<boolean> = {};

  constructor(
    private modal: ModalService,
    private restApi: RestApiService,
    private user: UserService,
    private formBuilder: FormBuilder,
    private secureFile: SecureFilePipe,
    private working: WorkingService,
    iconRegistry: UIKitIconRegistry,
  ) {
    iconRegistry.registerIcons([
      downloadIcon,
      closeIcon,
    ]);
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.modal.close(MODAL_ID);
  }

  onFormSubmit(event: Event) {

    event.preventDefault();

    const value = this.form.value;

    const application = this.user.application.id;

    const referTo = environment.defaultBroker;

    this.form.disable();
    this.working.add({ uiBlocking: true }, 'refer-to-broker-modal');

    this.restApi
      .referToBroker({ application, broker: referTo })
      .pipe(
        switchMap(() => this.user.update({
          phone: value.phone
        })),
        switchMap(() => this.user.updateApplication({
          has_clean_credit_record: value.clean_credit
        })),
        switchMap(() => this.restApi
          .getMip(application)
          .pipe(tap(({ key }) => this.downloadMip(key))))
      )
      .toPromise()
      .then(() => {
        this.onSuccess.emit();

        asapScheduler
          .schedule(() => this.open = false);
      })
      .catch((error) => this.modal.open(error?.message))
      .finally(() => {
        this.working.remove('refer-to-broker-modal');
        this.form.enable();
      });
  }

  downloadMip(key: string) {
    this.secureFile
      .transform(key)
      .toPromise()
      .then(this.downloadFromURI.bind(this))
      .catch((error) => this.modal.open(error?.message));
  }

  private downloadFromURI(uri: string) {
    const aElement = document.createElement('a');
    aElement.download = 'Mortgage In Principle';
    aElement.href = uri;
    aElement.click();
    aElement.remove();
  }
}
